export enum CountedDataType {
    EMPLOYEES = 'EMPLOYEES',
    ORDERS = 'ORDERS',
    ROWS = 'ROWS',
    INVENTORY = 'inventory',
    INVENTORY_ITEM = 'inventory item',
    SuiteCatering = 'suite_catering',
    TRANSFER = 'transfer',
    PRODUCT = 'product',
    ACCOUNT_INVOICE = 'account_invoice',
    STAND_WORKSHEET_CLOSING = 'stand_worksheet_closing',
    PHYSICAL_TERMINAL_SALES = 'physical_terminal_sales',
    RECIPE_DEPLETIONS = 'recipe_depletions',
    TRANSFER_BY_ITEM = 'transfer_by_item',
    PHYSICAL_SALES_ACCOUNTING = 'physical_sales_accounting',
    INVENTORY_PURCHASE_SUMMARY = 'inventory_purchase_summary',
    TRANSFER_PICK_SHEET = 'transfer_pick_sheet',
    INVENTORY_COST_OF_GOODS_SOLD = 'inventory_cost_of_goods_sold',
}

export enum ReportType {
    EMPLOYEE_SCORECARD = 'employeeScorecardReport',
    EMPLOYEE_DISCOUNT = 'employeeDiscountReport',
    ENTERPRISE_SALES_SUMMARY = 'enterpriseSalesSummaryReport',
    ORDER_EXPLORER = 'orderExplorerReport',
    ORDER_PAYMENTS = 'orderPaymentsReport',
    INVENTORY_ITEM_LISTING = 'inventoryItemListingReport',
    Suite_Catering_Production = 'suiteCateringProductionReport',
    ORDER_SUMMARY = 'orderSummaryReport',
    Notes_Questions = 'notesAndQuestionsReport',
    TRANSFER_SUMMARY = 'transferSummaryReport',
    SUITE_PAYMENT = 'suitePayment',
    SUITE_ORDER_SUMMARY = 'suiteOrderSummaryReport',
    INVENTORY_ON_HAND = 'inventoryOnHandReport',
    PRODUCT_LISTING = 'productListingReport',
    PAID_OUT_TIPS_DETAIL = 'paidOutTipsDetail',
    INVENTORY_COUNT = 'inventoryCountReport',
    ACCOUNT_INVOICE = 'accountInvoice',
    SUITE_ITEM_SALES = 'suiteItemSalesReport',
    STAND_WORKSHEET_CLOSING = 'standWorksheetClosing',
    PHYSICAL_TERMINAL_SALES = 'physicalTerminalSales',
    SALES_OVER_SHORT = 'salesOverShort',
    CASH_DRAWER_SUMMARY = 'cashDrawerSummary',
    PAID_IN_OUT_DETAIL = 'paidInOutDetail',
    DEPOSIT_SUMMARY = 'depositSummary',
    EMPLOYEE_SALES = 'employeeSales',
    GIFT_CARD_ACTIVITY = 'giftCardActivity',
    ITEM_COMMENTS = 'itemComments',
    LABOR_PERFORMANCE_BY_HOUR = 'laborPerformanceByHour',
    MISSED_BREAKS = 'missedBreaks',
    MODIFIER_ANALYSIS_BY_PRODUCT_CATEGORY = 'modifierAnalysisByProductCategory',
    SPEED_OF_SERVICE_CHECK_AUDIT = 'speedOfServiceCheckAudit',
    SPEED_OF_SERVICE_PERFORMANCE = 'speedOfServicePerformance',
    PRODUCT_MIX = 'productMix',
    PRIMARY_LABOR_BY_HOUR = 'primaryLaborByHour',
    SALES_AND_LABOR_BY_TIME = 'salesAndLaborByTime',
    SALES_AND_TRANSACTION = 'salesAndCountTransactionByTime',
    SUITE_TIP = 'suiteTip',
    RECIPE_DEPLETIONS = 'recipeDepletions',
    PRODUCT_SOLD_BY_TIME = 'productSoldByTime',
    SUITE_ORDER_ASSIGNMENTS = 'suiteOrderAssignments',
    SHIPPING = 'shipping',
    TRANSFER_BY_ITEM = 'transferByItem',
    LIABILITY_DETAIL = 'LiabilityDetail',
    EMPLOYEES_ON_THE_CLOCK = 'employeesOnTheClock',
    PAYROLL_SUMMARY = 'payrollSummaryReport',
    VOID_SUMMARY = 'voidSummaryReport',
    DISCOUNT_SUMMARY = 'discountSummaryReport',
    NO_SALE_BY_EMPLOYEE = 'noSaleByEmployee',
    PHYSICAL_SALES_ACCOUNTING = 'physicalSalesAccounting',
    CREDIT_CARD_EXPIRATION = 'creditCardExpiration',
    INVENTORY_PURCHASE_SUMMARY = 'inventoryPurchaseSummary',
    TRANSFER_PICK_SHEET = 'transferPickSheet',
    WEEKLY_SALES = 'weeklySalesReport',
    WEEKLY_SALES_AND_LABOR_HISTORY = 'weeklySalesAndLaborHistory',
    PRODUCT_SALES_BY_CATEGORY = 'productSalesByCategory',
    INVENTORY_COST_OF_GOODS_SOLD = 'inventoryCostOfGoodsSold',
    IDLE_TIME_TRACKING = 'idleTimeTracking',
    DISCOUNTED_ITEMS_BY_REPORTING_CATEGORY = 'discountedItemsByReportingCategory',
    LABOR_PERFORMANCE_SUMMARY = 'laborPerformanceSummaryReport',
    IRIS_PAYROLL_SUMMARY = 'irisPayrollSummary',
    WEB_SRM = 'webSRM',
    LABOR_PERFORMANCE_BY_USER = 'laborPerformanceByUserReport',
    UNAVAILABLE_PRODUCTS = 'unavailableProductsReport',
    TAX_EXEMPT_SALES = 'taxExemptSalesReport',
    TIMECARD_AUDIT = 'timecardAuditReport',
}

export enum ReportDetailType {
    VOID_SUMMARY_DETAIL = 'voidSummaryDetailReport',
    DISCOUNT_SUMMARY_DETAIL = 'discountSummaryDetail',
}

export enum ReportName {
    EMPLOYEE_SCORECARD = 'employee_scorecard',
    EMPLOYEE_DISCOUNT = 'employee_discount',
    ENTERPRISE_SALES_SUMMARY = 'enterprise_sales_summary',
    ORDER_EXPLORER = 'order_explorer',
    ORDER_PAYMENTS = 'order_payments',
    INVENTORY_ITEM_LISTING = 'inventory_item_listing',
    Suite_Catering_Production = 'suite_catering_production',
    Notes_Questions = 'notes_and_questions',
    SUITE_PAYMENT = 'suite_payment',
    ORDER_SUMMARY = 'order_summary',
    TRANSFER_SUMMARY = 'transfer_summary',
    SUITE_ORDER_SUMMARY = 'suite_order_summary',
    INVENTORY_ON_HAND = 'inventory_on_hand',
    PRODUCT_LISTING = 'product_listing',
    PAID_OUT_TIPS_DETAIL = 'paid_out_tips_detail',
    INVENTORY_COUNT = 'inventory_count',
    ACCOUNT_INVOICE = 'account_invoice',
    SUITE_ITEM_SALES = 'suite_item_sales',
    STAND_WORKSHEET_CLOSING = 'stand_worksheet_closing',
    PHYSICAL_TERMINAL_SALES = 'physical_terminal_sales',
    SALES_OVER_SHORT = 'sales_over_short',
    CASH_DRAWER_SUMMARY = 'cash_drawer_summary',
    PAID_IN_OUT_DETAIL = 'paid_in_out_detail',
    DEPOSIT_SUMMARY = 'deposit_summary',
    EMPLOYEE_SALES = 'employee_sales',
    GIFT_CARD_ACTIVITY = 'gift_card_activity',
    ITEM_COMMENTS = 'item_comments',
    LABOR_PERFORMANCE_BY_HOUR = 'labor_performance_by_hour',
    MISSED_BREAKS = 'missed_breaks',
    MODIFIER_ANALYSIS_BY_PRODUCT_CATEGORY = 'modifier_analysis_by_product_category',
    SPEED_OF_SERVICE_CHECK_AUDIT = 'speed_of_service_check_audit',
    SPEED_OF_SERVICE_PERFORMANCE = 'speed_of_service_performance',
    PRODUCT_MIX = 'product_mix',
    PRIMARY_LABOR_BY_HOUR = 'primary_labor_by_hour',
    SALES_AND_LABOR_BY_TIME = 'sales_and_labor_by_time',
    SALES_AND_TRANSACTION = 'sales_and_transaction_count_by_time',
    SUITE_TIP = 'suite_tip',
    RECIPE_DEPLETIONS = 'recipe_depletions',
    PRODUCT_SOLD_BY_TIME = 'product_sold_by_time',
    SUITE_ORDER_ASSIGNMENTS = 'suite_order_assignments',
    SHIPPING = 'shipping',
    TRANSFER_BY_ITEM = 'transfer_by_item',
    LIABILITY_DETAIL = 'liability_detail_report',
    EMPLOYEES_ON_THE_CLOCK = 'employees_on_the_clock',
    PAYROLL_SUMMARY = 'payroll_summary',
    VOID_SUMMARY = 'voids_summary',
    DISCOUNT_SUMMARY = 'discount_summary',
    NO_SALE_BY_EMPLOYEE = 'no_sale_by_employee',
    PHYSICAL_SALES_ACCOUNTING = 'physical_sales_accounting',
    CREDIT_CARD_EXPIRATION = 'credit_card_expiration',
    INVENTORY_PURCHASE_SUMMARY = 'inventory_purchase_summary',
    TRANSFER_PICK_SHEET = 'transfer_pick_sheet',
    WEEKLY_SALES = 'weekly_sales',
    WEEKLY_SALES_AND_LABOR_HISTORY = 'weekly_sales_and_labor_history',
    PRODUCT_SALES_BY_CATEGORY = 'category_sales_per_site',
    INVENTORY_COST_OF_GOODS_SOLD = 'inventory_cost_of_goods_sold',
    IDLE_TIME_TRACKING = 'idle_time_tracking',
    DISCOUNTED_ITEMS_BY_REPORTING_CATEGORY = 'discounted_items_by_reporting_category',
    IRIS_PAYROLL_SUMMARY = 'iris_payroll_summary',
    WEB_SRM = 'web_srm',
    LABOR_PERFORMANCE_BY_USER = 'labor_performance_by_user',
    LABOR_PERFORMANCE_SUMMARY = 'labor_performance_summary',
    UNAVAILABLE_PRODUCTS = 'unavailable_products',
    TAX_EXEMPT_SALES = 'tax_exempt_sales_report',
    TIMECARD_AUDIT = 'timecard_audit_report',
}

export enum ReportDetailName {
    VOID_SUMMARY_DETAIL = 'void_summary_detail',
    DISCOUNT_SUMMARY_DETAIL = 'discount_summary_detail',
    UNAVAILABLE_PRODUCTS_DETAIL = 'unavailable_products_detail',
}

export enum ReportTitle {
    ITEM_COMMENTS = 'Item Comments',
    LABOR_PERFORMANCE_BY_HOUR = 'Labor Performance By Hour',
    MISSED_BREAKS = 'Missed Breaks',
    MODIFIER_ANALYSIS_BY_PRODUCT_CATEGORY = 'Modifier Analysis by Product Category',
    SPEED_OF_SERVICE_CHECK_AUDIT = 'Speed of Service Check Audit',
    SPEED_OF_SERVICE_PERFORMANCE = 'Speed of Service Performance',
    SALES_AND_LABOR_BY_TIME = 'Sales and Labor by Time',
    LIABILITY_DETAIL = 'Liability Detail',
    EMPLOYEES_ON_THE_CLOCK = 'Employees On The Clock',
    VOID_SUMMARY = 'Void Summary',
    NO_SALE_BY_EMPLOYEE = 'No Sale By Employee',
    PRODUCT_SALES_BY_CATEGORY = 'Product Sales By Category',
    IDLE_TIME_TRACKING = 'Idle Time Tracking',
    DISCOUNTED_ITEMS_BY_REPORTING_CATEGORY = 'Discounted Items By Reporting Category',
    LABOR_PERFORMANCE_BY_USER = 'Labor Performance By User',
    LABOR_PERFORMANCE_SUMMARY = 'Labor Performance Summary',
}

export enum DynamicFieldsGroupName {
    IR_TAGS = 'incidence_rates',
    NONE = 'none',
}

export enum ReportID {
    STAND_WORKSHEET_CLOSING = 'stand_worksheet_closing',
    INVENTORY_ITEM_LISTING = 'inventory_item_listing',
    ORDER_SUMMARY = 'order_summary',
    TRANSFER_SUMMARY = 'transfer_summary',
    INVENTORY_ON_HAND = 'inventory_on_hand',
    PRODUCT_LISTING = 'product_listing',
    INVENTORY_COUNT = 'inventory_count',
    PHYSICAL_TERMINAL_SALES = 'physical_terminal_sales',
    SALES_OVER_SHORT = 'sales_over_short',
    RECIPE_DEPLETIONS = 'recipe_depletions',
    TRANSFERS_BY_ITEM = 'transfers_by_item',
    PHYSICAL_SALES_ACCOUNTING = 'physical_sales_accounting',
    TRANSFER_PICK_SHEET = 'transfer_pick_sheet',
    INVENTORY_PURCHASE_SUMMARY = 'inventory_purchase_summary',
    INVENTORY_COST_OF_GOODS_SOLD = 'inventory_cost_of_goods_sold',
}

export const XVITypeReport: string[] = [
    ReportID.STAND_WORKSHEET_CLOSING,
    ReportID.INVENTORY_ITEM_LISTING,
    ReportID.ORDER_SUMMARY,
    ReportID.TRANSFER_SUMMARY,
    ReportID.INVENTORY_ON_HAND,
    ReportID.PRODUCT_LISTING,
    ReportID.INVENTORY_COUNT,
    ReportID.PHYSICAL_TERMINAL_SALES,
    ReportID.SALES_OVER_SHORT,
    ReportID.RECIPE_DEPLETIONS,
    ReportID.TRANSFERS_BY_ITEM,
    ReportID.PHYSICAL_SALES_ACCOUNTING,
    ReportID.TRANSFER_PICK_SHEET,
    ReportID.INVENTORY_PURCHASE_SUMMARY,
    ReportID.INVENTORY_COST_OF_GOODS_SOLD,
];
